export default __webpack_public_path__ + "static/media/photo1.e0758771.jpg";